import React, { useEffect, useRef, useState } from "react";

const CustomSelectEditor = (props) => {
  const {
    label,
    value,
    stopEditing,
    values = [],
    api,
    node,
    column,
    tableKey,
  } = props;
  const dropdownRef = useRef(null);
  const [selectedValue, setSelectedValue] = useState(value);

  const getDisplayField = (item) => {
    return tableKey === "remediation_report" ? item.name : item.prefix;
  };

  useEffect(() => {
    if (dropdownRef.current) {
      dropdownRef.current.focus();
    }
  }, []);

  const handleChange = (event) => {
    const newItem = values.find(
      (item) => getDisplayField(item) === event.target.value
    );
    if (newItem) {
      setSelectedValue(getDisplayField(newItem));
      api.getRowNode(node.id).setDataValue(column.colId, newItem);
    }
    stopEditing();
  };

  return (
    <select
      ref={dropdownRef}
      value={selectedValue || ""}
      onChange={handleChange}
      style={{ width: "100%", height: "100%", border: "none", outline: "none" }}
    >
      <option value="" disabled>
        {tableKey === "tier" ? "- Select Tier -" : label}
      </option>

      {values.map((item) => (
        <option
          key={item.title || getDisplayField(item)}
          value={getDisplayField(item)}
        >
          {tableKey === "tier" ? item.prefix : getDisplayField(item)}
        </option>
      ))}
    </select>
  );
};

export default CustomSelectEditor;
